// extracted by css-extract-rspack-plugin
export default {"box":"Sud18jzKXY09Yvr2","icon":"EZTOcoXZgdU7PSOd","checkbox":"joUfB6pjXZIkoGIP yjEOWr1wvMI7B708","container":"JbPmDQV4N90yKTNY"};